<template>
  <div class="login">
    <div class="top flex flex-vertical">
      <div class="logo"></div>
      <div class="content">
        <div class="account-wrap">
          <Input v-if="loginType === 'email'" v-model.trim="account" class="phone" size="large" :placeholder="$t('email')" />
          <div class="email-wrap" v-if="loginType === 'mobile'">
            <Dropdown trigger="click" class="csc-wrap" placement="bottom-start" @on-click="cscClick">
              <a class="csc" href="javascript:void(0)">
                <span>+</span>
                <span>{{ csc }}</span>
                <div class="icon"></div>
              </a>
              <DropdownMenu slot="list">
                <template v-for="(item, index) in cscConf">
                  <DropdownItem :name="item.csc" :key="index">
                    <div class="left">+{{ item.csc }}</div>
                    <div class="right">{{ item.name }}</div>
                  </DropdownItem>
                </template>
              </DropdownMenu>
            </Dropdown>
            <Input v-model.trim="account"  number class="email" size="large" :placeholder="$t('mobile')" />
          </div>
        </div>
      </div>
      <div class="tips"><span @click="goHelp">{{ $t('tips_text') }}</span></div>
      <div class="btns">
        <Button type="warning" :class="!btnEnable ? 'disabled' : ''" @click="clickSendCode()">
          <div>
            {{ $t('get_code') }} {{ cd > 0 ? `(${cd}S)` : '' }}
            <span v-if="loading" class="loading"></span>
          </div>
        </Button>
      </div>
      <Divider>OR</Divider>
      <div class="social-list" :class="agree ? '' : 'disabled'">
        <div class="item" :class="loginType === 'mobile' ? 'email' : 'mobile'" @click="toggle"></div>
        <template v-if="routerParams.from !== 'bind'">
          <template v-for="(item, index) in socialConf">
            <components
              @click.native="checkAgreement"
              :account="`${account}`"
              class="social-item"
              :key="index"
              :is="item.type"
            ></components>
          </template>
        </template>
      </div>
    </div>
    <div class="agree">
      <div class="flex flex-horizontal">
        <div class="checkbox" :class="agree ? 'active' : ''" @click="agree = !agree"></div>
        <i18n path="text_agree" tag="div" class="text">
          <slot name="0">
            <span class="link" @click="jumpUrl('privacy')">{{ $t('privacy') }}</span>
          </slot>
          <slot name="1">
            <span class="link" @click="jumpUrl('agreement')">{{ $t('agreement') }}</span>
          </slot>
        </i18n>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { sendCode } from '../api'
import Facebook from './social/Facebook.vue'
import Google from './social/Google.vue'
import { VerifySM } from '../utils/SMCaptcha'
import { openBrowser } from '../utils/Qtbridge'
const helpShiftUrl = 'https://ss-pc.funplus.com/faq'
export default {
  name: 'login',
  components: { Facebook, Google },
  data () {
    return {
      agree: false,
      account: '',
      csc: '',
      socialConf: [
        { type: 'Facebook' },
        { type: 'Google' }
        // { type: 'Vk' }
      ],
      loginType: 'email',
      loading: false,
      cd: 0,
      timer: null,
      
      routerParams: {
        from: this.$route.query.from,
        loginType: this.$route.query.loginType
      }
    }
  },
  created () {
    this.loginType = this.routerParams.loginType || 'email'
    this.csc = this.config.default_mobile_csc
    this.initCd()
    this.$gtag.event('old_page2_login', {})
  },
  activated() {
    this.initCd()
  },
  watch: {
    'config.default_mobile_csc': {
      handler (nv) {
        this.csc = nv || '86'
      }
    }
  },
  computed: {
    ...mapState({
      cscConf: state => state.cscConf,
      config: state => state.config
    }),
    btnEnable () {
      if (this.loading) return false
      if (this.cd > 0) return false
      if (!this.account) return false
      if (this.loginType === 'mobile') {
        if (!this.csc) return false
      } else {
        if (!this.$utils.isEmail(this.account)) return false
      }
      if (!this.agree) return false
      return true
    }
  },
  methods: {
    initCd () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      const now = Math.ceil(new Date().getTime() / 1000)
      const sendTime = window.localStorage.getItem('sendTime') || 0
      const cd = 60 - (now - sendTime)
      if (cd > 0) {
        this.cd = cd
        this.timer = setInterval(() => {
          if (this.cd === 0) {
            clearInterval(this.timer)
            this.timer = null
          }
          this.cd -= 1
        }, 1000);
      }
    },
    clickSendCode (verifyData) {
      if (!this.agree) {
        return this.$msg.success(this.$t('agreement_tips'))
      }
      if (!this.btnEnable) return

      if (this.loading) return
      const params = {
        code_type: 1
      }
      if (this.loginType === 'mobile') {
        params.bind_type = 101
        params.mobile = `${this.account}`
        params.csc = this.csc
        if (!/^[0-9-]+$/.test(this.account)) {
          return this.$msg.success(this.$t('tips_mobile'))
        }
      } else if (this.loginType === 'email') {
        params.bind_type = 102
        params.email = this.account
        if (!this.$utils.isEmail(this.account)) {
          return this.$msg.success(this.$t('tips_mail'))
        }
      }
      if (verifyData) {
        params.verify_data = verifyData
        params.captcha_channel = 'sm'
      }
      this.loading = true
      sendCode(params)
        .then(() => {
          delete params.verify_data
          delete params.captcha_channel
          window.localStorage.setItem('sendTime', Math.floor(new Date().getTime() / 1000))
          this.loading = false
          this.$router.push({
            name: 'Verify2',
            query: {
              ...params,
              ...this.routerParams
            }
          })
        })
        .catch(err => {
          if (err.code === 110011) {
            VerifySM(data => {
              if (data.pass) {
                this.clickSendCode(data)
              }
            })
          } else {
            this.$msg.success(err.msg)
          }
          this.loading = false
        })
      this.$utils.log('pc_login_action', {
        login_action: 'click_code'
      })
    },
    
    // 登录遇到问题?
    goHelp () {
      openBrowser(helpShiftUrl)
    },

    // 手机/邮箱登陆切换
    toggle () {
      this.account = ''
      if (this.loginType === 'mobile') {
        this.$utils.log('pc_login_action', {
          login_action: 'click_email'
        })
      } else {
        this.$utils.log('pc_login_action', {
          login_action: 'click_mobile'
        })
      }
      this.loginType = this.loginType === 'mobile' ? 'email' : 'mobile'
    },

    // 选择区号
    cscClick (csc) {
      this.csc = csc
    },
    
    jumpUrl (type) {
      let url = ''
      if (type === 'privacy') {
        url = this.config.privacy_agreement
      } else {
        url = this.config.user_agreement
      }
      openBrowser(url)
    },

    checkAgreement () {
      if (!this.agree) {
        return this.$msg.success(this.$t('agreement_tips'))
      }
    }
  },
  deactivated () {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
    this.timer = null
  }
}
</script>

<style lang='less' scoped >
.login {
  padding: 0 30px;
  .top {
    align-items: center;
    padding-top: 9px;
  }
  .logo {
    width: 100px;
    height: 25px;
    background: url(~@img/logo.png) center center no-repeat;
    background-size: 100% 100%;
  }
  .account-wrap {
    margin-top: 42px;
    width: 360px;
    height: 48px;
    .email-wrap {
      display: flex;
    }
    .csc-wrap {
      flex-shrink: 0;
      width: 70px;
      height: 48px;
      display: flex;
      margin-right: 10px;
      align-items: center;
      justify-content: center;
      background-color: #fff;
      border-radius: 8px;
      box-shadow: 0px 11px 19px 2px rgba(0, 0, 0, 0.02);
      /deep/ .ivu-dropdown-rel {
        width: 100%;
        height: 100%;
      }
      .ivu-dropdown-menu {
        width: 360px;
      }
      .ivu-dropdown-item {
        padding: 0;
        margin: 0 14px;
        height: 50px;
        font-size: 16px !important;
        line-height: 18px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        white-space: normal;
        &+.ivu-dropdown-item {
          border-top: 1px solid #EEEEEE;
        }
        .left {
          width: 60px;
          flex-shrink: 0;
        }
        .right {
          text-align: right;
        }
      }
      .csc {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #111 !important;
        font-size: 16px;
        span {
          line-height: 1;
        }
      }
      .icon {
        width: 11px;
        height: 5px;
        margin-left: 6px;
        background: url(~@img/icon_arr.png) center center no-repeat;
        background-size: 100% 100%;
      }
    }
  }
  .tips {
    width: 100%;
    height: 16px;
    text-align: right;
    font-size: 14px;
    font-weight: 400;
    text-decoration: underline;
    color: #999999;
    line-height: 15px;
    margin-top: 10px;
    span {
      cursor: pointer;
    }
  }
  .btns {
    width: 100%;
    margin-top: 18px;
    .disabled {
      color: #FFAD80;
    }
    div {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .loading {
      opacity: 0.4;
      display: inline-block;
      width: 18px;
      height: 18px;
      background-image: url(~@img/icon_loading.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center;
      transform-origin: center;
      margin-left: 10px;
      animation: ani-load-loop 2s linear infinite;
    }
  }
  .social-list {
    display: flex;
    align-items: center;
    .item {
      width: 31px;
      height: 31px;
      background: url(~@img/icon_mail.png) center center no-repeat;
      background-size: 100% 100%;
      &.mobile { background-image: url(~@img/icon_mobile.png); }
      &.email { background-image: url(~@img/icon_mail.png); }
    }
    .social-item {
      width: 32px;
      height: 32px;
      overflow: hidden;
    }
    &.disabled {
      .social-item {
        overflow: hidden;
        position: relative;
        &::after {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          cursor: not-allowed;
        }
      }
    }
    &>div {
      margin: 0 20px;
      cursor: pointer;
    }
  }
  
  .agree {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 45px;
    margin: 0 -6px;
    .checkbox {
      flex-shrink: 0;
      margin-right: 10px;
      width: 19px;
      height: 19px;
      background-image: url(../assets/img/checkbox.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center;
      cursor: pointer;
      &.active {
        background-image: url(../assets/img/checkbox_active.png);
      }
    }
    .text {
      padding-top: 2px;
      font-size: 12px;
      color: #999999;
      font-weight: 500;
      line-height: 15px;
    }
    .link {
      color: #668ece;
      cursor: pointer;
    }
  }
}
@keyframes loading {
  0% {
    rotate: 0;
  }
  50% {
    rotate: 180deg;
  }
  100% {
    rotate: 360deg;
  }
}
</style>
